import CryptoJS from 'crypto-js';

// 프로젝트 이름에 맞게 키 설정
// "nosp_inventory"에 기반한 키와 IV 생성
const key = CryptoJS.enc.Utf8.parse('___dmcmedia___thedap_____key____'); // 16, 24, or 32 bytes key
const iv = CryptoJS.enc.Utf8.parse('dmcmediakeythdap'); // 16 bytes IV


// 암호화
export function encrypteTarget(text) {
  const encrypted = CryptoJS.AES.encrypt(text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}

// 복호화
export function decrypteTarget(encrypted) {
  const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return CryptoJS.enc.Utf8.stringify(decrypted);
} 